<div class="main-black border-radius-bottom white-box p-4 mt-3" *ngIf="tableData.length > 0">
<!-- Truck devices Report-->
	<div>
		<div class="d-flex justify-content-between">
			<h2>{{ 'maintenance_schedule.trucks_maintenance_report' | translate }}</h2>
			<button class="btn btn-primary ml-2" (click)="openLastPMModal()" [disabled]="!selectedDevices.length">
				{{'actions.set_last_maintenance_date' | translate}}
			</button>
		</div>
		<sct-custom-table
			[columnsConfig]="columnConfig"
			[data]="tableData"
			[config]="tableConfig"
			(updateSelectedRows)="updateSelectedIotahDevices($event)"
		></sct-custom-table>
	</div>
</div>

<!-- ChargLink And BRM Devices Report -->
<div class="main-black border-radius-bottom white-box p-4 mt-3" *ngIf="chargLinkDevicesMaintenanceReport.data.length > 0">
	<div>
		<div class="d-flex justify-content-between"> 
			<h2>{{ 'maintenance_schedule.chargers_maintenance_report' | translate }}</h2>
			<button class="btn btn-primary ml-2" (click)="openLastPMModal()" [disabled]="!selectedChargLinkDevices.length">
				{{'actions.set_last_maintenance_date' | translate}}
			</button>
		</div>
		<sct-custom-table
			[columnsConfig]="chargLinkDevicesMaintenanceReport.column"
			[data]="chargLinkDevicesMaintenanceReport.data"
			[config]="chargLinkDevicesMaintenanceReport.config"
			(updateSelectedRows)="updateSelectedChargLinkDevices($event)"
		></sct-custom-table>
	</div>
</div>

<!-- Battlink Devices Report -->
<div class="main-black border-radius-bottom white-box p-4 mt-3" *ngIf="battlinkDevicesMaintenanceReport.data.length > 0">
	<div>
		<div class="d-flex justify-content-between">
			<h2>{{ 'maintenance_schedule.batteries_maintenance_report' | translate }}</h2>
			<button class="btn btn-primary ml-2" (click)="openLastPMModal()" [disabled]="!selectedBattlinkDevices.length">
				{{'actions.set_last_maintenance_date' | translate}}
			</button>
		</div>
		<sct-custom-table
			[columnsConfig]="battlinkDevicesMaintenanceReport.column"
			[data]="battlinkDevicesMaintenanceReport.data"
			[config]="battlinkDevicesMaintenanceReport.config"
			(updateSelectedRows)="updateSelectedBattlinkDevices($event)"
		></sct-custom-table>
	</div>
</div>

<app-modal #lastPMModal title="{{'actions.set_last_maintenance_date' | translate}}" [hasConfirmButton]="false" [hasCloseButton]="false">
	<div class="mb-5" *ngIf="lastPMModalVars.min && lastPMModalVars.max">
		<input
			class="form-control"
			[ngClass]="{'invalid-input' : !lastPMModalVars.isValid}"
			name="last_pm_date"
			placeholder="mm/dd/yyyy"
			[(ngModel)]="lastPMModalVars.lastPMDate"
			bsDatepicker #d="bsDatepicker" [bsConfig]="{ containerClass: 'theme-dark-blue' }" [minDate]="lastPMModalVars.min" [maxDate]="lastPMModalVars.max"
			(ngModelChange)="lastPMModalVars.isValid=true"
			check-permission="basic_setup"
			calender
		/>
		<p class="text-danger mt-2" *ngIf="!lastPMModalVars.isValid">{{'g.invalid_input' | translate}}!</p>
	</div>
	<div class="modal-footer">
		<button class="btn btn-default mr-2" (click)="lastPMModal.hide()">{{'g.cancel' | translate}}</button>
		<button class="btn btn-primary" (click)="setLastPMDate()" [disabled]="!lastPMModalVars.isValid">{{'g.ok' | translate}}</button>
	</div>
</app-modal>

<ng-container *ngIf="!tableData.length && !chargLinkDevicesMaintenanceReport.data.length && !battlinkDevicesMaintenanceReport.data.length">
	<div class="alert alert-info mt-4">
		{{'g.no_data_to_show' | translate}}
	</div>
</ng-container>